import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Typography } from "@mui/material";
import { SalesInvoice001_Custom, SalesInvoice001_CustomGetRow } from "../../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import { sTrnTyp } from "../DelieveryNoteAction";
import { DelieveryNoteRo } from "../../../Redux/roStore";

function CustomFieldsForm({ vocType = "", vocNo = "", vocTypeName = "" }) {
  const [formData, setFormData] = useState({
    customField1: "",
    customField2: "",
    customField3: "",
    customField4: "",
    customField5: "",
    customField6: "",
    customField7: "",
    customField8: "",
    customField9: "",
    customField10: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleClear = (e) => {
    setFormData({
      customField1: "",
      customField2: "",
      customField3: "",
      customField4: "",
      customField5: "",
      customField6: "",
      customField7: "",
      customField8: "",
      customField9: "",
      customField10: "",
    });
  };
  const handleSubmit = async (e) => {
    console.log(formData);
    let obj = {
      v_TrnTyp: sTrnTyp,
      v_VocTyp: vocType,
      v_VocNo: vocNo,
      v_CUSTFIELD1: formData.customField1,
      v_CUSTFIELD2: formData.customField2,
      v_CUSTFIELD3: formData.customField3,
      v_CUSTFIELD4: formData.customField4,
      v_CUSTFIELD5: formData.customField5,
      v_CUSTFIELD6: formData.customField6,
      v_CUSTFIELD7: formData.customField7,
      v_CUSTFIELD8: formData.customField8,
      v_CUSTFIELD9: formData.customField9,
      v_CUSTFIELD10: formData.customField10,
    };
    let resp = await SalesInvoice001_Custom(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      fAlertToast("SUCCESS", "Custom fields updated successfully ");
      // handleClear()
      CustGetRow()
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  };

  const CustGetRow=async()=>{
    const { HeadObject } = DelieveryNoteRo();
    let obj = {
      v_TrnTyp: sTrnTyp,
      v_VocTyp: HeadObject.A_VocTyp,
      v_VocNo: HeadObject.A_VocNo,
    };
    let resp = await SalesInvoice001_CustomGetRow(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (resp?.status === 200) {
      console.log(resp);
      if(resp?.data?.ResultSet?.length >0){
        let respData = resp?.data?.ResultSet[0];     
        setFormData((prevFormData)=>({...prevFormData, 
          customField1: respData.A_CUSTFIELD1,
          customField2: respData.A_CUSTFIELD2,
          customField3: respData.A_CUSTFIELD3,
          customField4: respData.A_CUSTFIELD4,
          customField5: respData.A_CUSTFIELD5,
          customField6: respData.A_CUSTFIELD6,
          customField7: respData.A_CUSTFIELD7,
          customField8: respData.A_CUSTFIELD8,
          customField9: respData.A_CUSTFIELD9,
          customField10: respData.A_CUSTFIELD10
        }))
      }else{
        handleClear()
      }
     
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  }


  useEffect(() => {
    CustGetRow()
  },[])
  return (
    <Grid container spacing={0.5}>
      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>GRN Type:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="grnType"
              value={vocTypeName}
              onChange={() => {}}
              // disabled // Assuming this field is not editable based on the image
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={3}>
            <Typography sx={{ color: "var(--primary)" }}>GRN No:</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              size="small"
              name="grnNo"
              value={vocNo}
              onChange={() => {}}
              // Assuming this field is not editable based on the image
            />
          </Grid>
        </Grid>
      </Grid>

      {/* Custom Fields */}
      {Array.from({ length: 10 }, (_, index) => (
        <Grid item xs={12} key={index}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={3}>
              <Typography sx={{ color: "var(--primary)" }}>
                Custom Field {index + 1}:
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                size="small"
                name={`customField${index + 1}`}
                value={formData[`customField${index + 1}`]}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Grid>
      ))}

      <Grid item xs={12} container justifyContent="center" spacing={2}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClear}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CustomFieldsForm;
